import React, { useState, useEffect } from "react";
import { PaystackButton } from "react-paystack";
import { toast } from "react-toastify";
import "../css/Billing.css";
import { useNavigate } from "react-router-dom";
import { secureStorage } from "../SecureStorage";

const Billing = () => {
  const [organization, setOrganization] = useState(null);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  // Paystack config
  const planCode = "PLN_43vhgkh0oceczkw"; // Live Plan
  // const planCode = "PLN_hcutzyousr8lxn4"; // Test Plan
  const publicKey = "pk_live_cc3edf16febc923216068158c985427718406d71"; // replace with your Paystack public key
  // const publicKey = "pk_test_2cee061bd9f220ff3a4863f7bf0c6702c9ac2922"

  // Fetch organization info (like in your dashboard)
  useEffect(() => {
    const fetchOrganization = async () => {
      setLoading(true);
      try {
        const token = secureStorage.getItem("auth_token");
        if (!token) {
          throw new Error("No authentication token found. Please log in.");
        }

        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/company/bio`, {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (!res.ok) {
          throw new Error(`Failed to fetch organization info: ${res.status}`);
        }

        const data = await res.json();
        setOrganization({
          company_name: data.company_name,
          company_handle: data.company_handle,
          company_email: data.company_email,
          company_id: data.company_id,
        });
        
      } catch (err) {
        console.error("Error fetching organization info:", err);
        toast.error("⚠️ Could not load organization details");
      } finally {
        setLoading(false);
      }
    };

    fetchOrganization();
  }, []);



  if (loading) {
    return (
      <div id="billingLoadingModal" className="modal-index-overlay">
        <div className="modal-index-content">
          <div className="dot-loader">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <p id="billing-modal-message">Loading Billing details...</p>
        </div>
      </div>
    );
  }
  

  if (!organization) {
    return <p>⚠️ Organization not found</p>;
  }

  const handlePaymentSuccess = async () => {
    toast.success("✅ Payment successful, subscription activated!");
    
    // Fetch latest organization info from backend
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/company/bio`);
      const data = await res.json();
      setOrganization({
        company_name: data.company_name,
        company_handle: data.company_handle,
        company_email: data.company_email,
        company_id: data.company_id,
        subscription_status: data.subscription_status, // ensure backend returns this
      });
  
      // Redirect to dashboard
      navigate("/dashboard");
    } catch (err) {
      console.error("Failed to fetch updated organization info:", err);
    }
  };
  

  const metadata = {
    app: "aboutme",
    org_id: organization.company_id,
    org_handle: organization.company_handle,
  };

  const componentProps = {
    email: organization.company_email, // 👈 use organization's email
    amount: 0, // ignored for recurring plan
    metadata,
    publicKey,
    plan: planCode,
    text: "Subscribe",
    onSuccess: handlePaymentSuccess, 
    // onSuccess: (ref) => {
    //   toast.success("✅ Payment successful, subscription activated!");
    //   console.log("Payment Success:", ref);
    //   // 🔥 Optional: call backend to confirm and update subscription
    // },
    onClose: () => {
      toast.info("💡 Payment window closed without subscribing.");
    },
  };

  return (
    <div className="pricing-container">
      <h2 className="pricing-title">Subscribe to QueryBox</h2>
      <p className="pricing-description">
        Unlock premium features with our Standard Plan.
      </p>

      <div className="pricing-box">
        <h3 className="text-xl font-bold mb-2">Standard Plan</h3>
        <p className="pricing-amount">₦10,000 / month</p>
        <p className="pricing-note">Billed automatically every month</p>

        {/* Subscribe button above features */}
        <div style={{ marginTop: "1.5rem" }}>
            {organization ? (
                <PaystackButton {...componentProps} className="paystack-btn" />
            ) : (
                <p>Loading payment info...</p> // optional placeholder while fetching
            )}
        </div>

        {/* <div style={{ marginTop: "1.5rem" }}>
          <PaystackButton {...componentProps} className="paystack-btn" />
        </div> */}

        <ul className="pricing-features">
          <li>Upload documents (up to 100MB)</li>
          <li>AI-powered Q&A on your data</li>
          <li>Automatic knowledge updates</li>
          <li>Organization dashboard</li>
          <li>Role-based access control</li>
          <li>Secure storage & encryption</li>
          <li>Priority email & chat support</li>
          <li>Unlimited access to premium tools</li>
          <li>Priority support</li>
          <li>Cancel anytime</li>
        </ul>
      </div>
    </div>
  );
};

export default Billing;

